export default __webpack_public_path__ + "static/media/pointer.e615cec8.png";